// Generated by CoffeeScript 2.5.1

import './App.css'
import database from './database'
import wordScore from './score'

import React, { Component } from 'react'
import { Box, Button, FormControl, FormControlLabel, FormGroup, Grid, Radio, RadioGroup, Switch } from '@mui/material';
;
var App, COLOR, ColorSelector, ColoredLetter, HardMode, NextTry, NextTryLetter, Tries, Try, occurrencesOf, previousOccurrencesOf, prospectiveColorFor, version,
  boundMethodCheck = function(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new Error('Bound instance method accessed before binding'); } };

({version} = require('../package.json'));

// Normal colors
COLOR = {
  PRESENT: "#c9b458",
  CORRECT: "#6aaa64",
  ABSENT: "#787c7e",
  BACKGROUND: "#ffffff",
  TEXT: "#ffffff",
  PROSPECTIVE_PRESENT: "#e7dfb7",
  PROSPECTIVE_CORRECT: "#c4ddc2",
  PROSPECTIVE_ABSENT: "#ced0d1"
};

// # Dark theme colors
// COLOR =
//   PRESENT:    "#b59f3b"
//   CORRECT:    "#538d4e"
//   ABSENT:     "#3a3a3c"
//   BACKGROUND: "#121213"

// Counts the number of occurrences of a letter in a word
occurrencesOf = function(letter, word) {
  var c, count, j, len;
  count = 0;
  for (j = 0, len = word.length; j < len; j++) {
    c = word[j];
    if (c === letter) {
      count++;
    }
  }
  return count;
};

// Counts the number of previous occurrences of this letter in the word
previousOccurrencesOf = function(letter, word, i) {
  var c, count, j, len, ref;
  count = 0;
  ref = word.slice(0, i);
  for (j = 0, len = ref.length; j < len; j++) {
    c = ref[j];
    if (c === letter) {
      count++;
    }
  }
  return count;
};

prospectiveColorFor = function(color) {
  switch (color) {
    case COLOR.ABSENT:
      return COLOR.PROSPECTIVE_ABSENT;
    case COLOR.PRESENT:
      return COLOR.PROSPECTIVE_PRESENT;
    case COLOR.CORRECT:
      return COLOR.PROSPECTIVE_CORRECT;
    default:
      if (color != null) {
        console.error(`prospectiveColorFor: Invalid color \"${color}\"`);
      }
  }
  return COLOR.BACKGROUND;
};

ColoredLetter = function(props) {
  var color, letter;
  ({letter, color} = props);
  return <Grid item xs={1}>
    <Box sx={{
    backgroundColor: color
  }}> <font size={7} color={COLOR.TEXT}><b>{letter.toUpperCase()}</b></font></Box>
  </Grid>;
};

Try = function(props) {
  var colors, i, word;
  ({word, colors} = props);
  return <Grid container spacing={1} style={{
    paddingTop: 8,
    paddingLeft: 8
  }}>
    {(function() {
    var j, results;
    results = [];
    for (i = j = 0; j < 5; i = ++j) {
      results.push(<ColoredLetter letter={word[i]} color={colors[i]} key={i} />);
    }
    return results;
  })()}
  </Grid>;
};

Tries = function(props) {
  var t, tries;
  ({tries} = props);
  return <div>
    {(function() {
    var j, len, results;
    results = [];
    for (j = 0, len = tries.length; j < len; j++) {
      t = tries[j];
      results.push(<Try word={t.word} colors={t.colors} key={t.word} />);
    }
    return results;
  })()}
  </div>;
};

NextTryLetter = function(props) {
  var color, letter;
  ({letter, color} = props);
  return <Grid item xs={1}>
    <Box sx={{
    border: "2px solid lightgray",
    backgroundColor: color
  }}><font size={7}><b> {letter.toUpperCase()} </b></font> </Box>
  </Grid>;
};

ColorSelector = function(props) {
  var id, onChange;
  ({id, onChange} = props);
  return <FormControl>
    <RadioGroup onChange={function(event) {
    return onChange(id, event.target.value);
  }}>
      <FormControlLabel value={COLOR.ABSENT} control={<Radio />} label="gray" />
      <FormControlLabel value={COLOR.PRESENT} control={<Radio />} label="yellow" />
      <FormControlLabel value={COLOR.CORRECT} control={<Radio />} label="green" />
    </RadioGroup>
  </FormControl>;
};

NextTry = function(props) {
  var colors, hard, i, onColor, onNext, word;
  ({word, colors, hard, onNext, onColor} = props);
  return <div>
    <Grid container spacing={1} style={{
    paddingTop: 8,
    paddingLeft: 8
  }}>
      {(function() {
    var j, results;
    results = [];
    for (i = j = 0; j < 5; i = ++j) {
      results.push(<NextTryLetter key={i} letter={word[i]} color={hard ? prospectiveColorFor(colors[i]) : COLOR.BACKGROUND} />);
    }
    return results;
  })()}
    </Grid>
    <Grid container spacing={1} alignItems="center" style={{
    paddingTop: 8,
    paddingLeft: 8
  }}>
      {(function() {
    var j, results;
    results = [];
    for (i = j = 0; j < 5; i = ++j) {
      results.push(<Grid item xs={1} key={i}><ColorSelector id={i} onChange={onColor} /></Grid>);
    }
    return results;
  })()}
      <Grid item xs={1}> <Button variant="contained" onClick={onNext}>Next</Button> </Grid>
    </Grid>
  </div>;
};

HardMode = function(props) {
  var checked, onChange;
  ({checked, onChange} = props);
  return <FormGroup>
    <FormControlLabel control={<Switch checked={checked} onChange={function(event) {
    return onChange(event.target.checked);
  }} />} label="Hard mode" />
  </FormGroup>;
};

App = class App extends Component {
  constructor(props) {
    super(props);
    // Handles the Next button
    this.handleNext = this.handleNext.bind(this);
    // Handles color radio buttons
    this.handleColor = this.handleColor.bind(this);
    // Handles the hardmode switch
    this.handleHardMode = this.handleHardMode.bind(this);
    this.state = {
      tries: [],
      candidates: database,
      suggestion: this.pick(database, 0.1),
      colors: [],
      found: false,
      hard: false
    };
    return;
  }

  // Return the word with the highest score
  pick(candidates) {
    var c, j, len, maxScore, selection, work;
    // Find the highest score
    maxScore = candidates[0].score;
    for (j = 0, len = candidates.length; j < len; j++) {
      c = candidates[j];
      maxScore = Math.max(c.score, maxScore);
    }
    // Keep only candidates with scores equal to the max
    work = candidates.filter(function(entry) {
      return entry.score >= maxScore;
    });
    // Select one at random
    selection = Math.floor(Math.random() * work.length);
    return work[selection].word;
  }

  // Returns all candidates that don't have the letter, but if the letter is repeated then
  // only candidates with fewer occurrences are returned
  keepGray(candidates, letter, previous) {
    return candidates.filter(function(entry) {
      return occurrencesOf(letter, entry.word) <= previous;
    });
  }

  // Returns all candidates with this letter at a different spot, but if the letter is repeated then
  // only candidates with at least that number of times that many occurrences are returned
  keepYellow(candidates, letter, i, previous) {
    return candidates.filter(function(entry) {
      return letter !== entry.word[i] && occurrencesOf(letter, entry.word) > previous;
    });
  }

  // Returns all candidates with this letter at this spot
  keepGreen(candidates, letter, i) {
    return candidates.filter(function(entry) {
      return letter === entry.word[i];
    });
  }

  handleNext() {
    var c, candidates, found, i, j, k, l, len, letter, m, previous, ref, ref1, ref2, ref3, suggestion, tries;
    boundMethodCheck(this, App);
    ref = this.state.colors;
    // If any of the colors are not set, then ignore this
    for (j = 0, len = ref.length; j < len; j++) {
      c = ref[j];
      if (c == null) {
        return;
      }
    }
    // Eliminate candidates based on the response for each letter
    candidates = this.state.candidates.slice(0);
    found = true; // initially assume the word is the solution (gray and yellow responses will set to false)
    for (i = k = 0, ref1 = this.state.suggestion.length; (0 <= ref1 ? k < ref1 : k > ref1); i = 0 <= ref1 ? ++k : --k) {
      letter = this.state.suggestion[i];
      previous = previousOccurrencesOf(letter, this.state.suggestion, i);
      switch (this.state.colors[i]) {
        case COLOR.ABSENT:
          // Only keep words that don't have this letter
          candidates = this.keepGray(candidates, letter, previous);
          found = false; // This is not the solution
          break;
        case COLOR.PRESENT:
          // Only keep words with this letter at at a different spot
          candidates = this.keepYellow(candidates, letter, i, previous);
          found = false; // This is not the solution
          break;
        case COLOR.CORRECT:
          // Only keep words with this letter at this spot
          candidates = this.keepGreen(candidates, letter, i);
          break;
        default:
          console.error(`handleNext: Invalid color \"${this.state.colors[i]}\"`);
      }
    }
    // Update the list of tries
    tries = this.state.tries.concat([
      {
        word: this.state.suggestion,
        colors: this.state.colors
      }
    ]);
    // If not done, then compute new scores for remaining candidates and pick one
    if (!found) {
      if (this.state.hard) {
        for (i = l = 0, ref2 = candidates.length; (0 <= ref2 ? l < ref2 : l > ref2); i = 0 <= ref2 ? ++l : --l) {
          candidates[i].score = wordScore(candidates[i].word, candidates);
        }
        suggestion = this.pick(candidates);
      } else {
        for (i = m = 0, ref3 = database.length; (0 <= ref3 ? m < ref3 : m > ref3); i = 0 <= ref3 ? ++m : --m) {
          database[i].score = wordScore(database[i].word, candidates);
        }
        suggestion = this.pick(database);
      }
    } else {
      suggestion = "";
    }
    // Update with the new list of candidates and pick one for the next suggestion
    this.setState({tries, candidates, suggestion, found});
  }

  handleColor(id, color) {
    var colors;
    boundMethodCheck(this, App);
    colors = this.state.colors.slice(0);
    colors[id] = color;
    this.setState({colors});
  }

  handleHardMode(hard) {
    boundMethodCheck(this, App);
    this.setState({hard});
  }

  render() {
    return <div className="App">
      <Tries tries={this.state.tries} />
      {!this.state.found ? <NextTry word={this.state.suggestion} colors={this.state.colors} hard={this.state.hard} onNext={this.handleNext} onColor={this.handleColor} /> : void 0}
      <Grid container>
        <Grid item xs={6}><HardMode checked={this.state.hard} onChange={this.handleHardMode} /></Grid>
        <Grid item xs={6}><p style={{
      textAlign: "left"
    }}>Version: {version}</p></Grid>
      </Grid>
    </div>;
  }

};

export default App;
